const translation = {
  Product: "製品",
  "Header.productNav": "LUKKEY 製品",
  Feature: "特徴",
  "About Us": "私たちについて",
  FAQ: "FAQ",
  "Privacy Policy": "プライバシーポリシー",
  "Help Center": "ヘルプセンター",
  "Header.infoMenu": "その他",
  "Header.appNow": "アプリを入手",
  "Header.appModal.title": "今すぐ LUKKEY アプリを使う",
  "Header.appModal.subtitle": "プラットフォームを選択して、LUKKEY 公式モバイルアプリを入手してください。",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "iPhone に公式アプリをインストール。",
  "Header.appModal.iosButton": "開く",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Google Play で公式 Android アプリを入手。",
  "Header.appModal.googlePlayButton": "開く",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "最新版の公式 APK を直接ダウンロード。",
  "Header.appModal.androidButton": "ダウンロード",
  "Header.appModal.note": "公式モバイルダウンロードのみです。最新バージョンは上記リンクをご利用ください。",
  "Academy": "アカデミー",
  "Legal": "法務",
  "AboutUs.title": "LUKKEYについて",
  "AboutUs.lede": "LUKKEYは、デジタル資産の所有権に最高水準の安全性を提供することに専念するスイスのハードウェアウォレットブランドです。",
  "AboutUs.vision.closing": "あなたの鍵。あなたの資産。あなたの未来。",
  "AboutUs.quote": "LUKKEY は、人とデジタル資産の間に安全レイヤーを築きます。",
  "AboutUs.block1": "LUKKEY はスイスを拠点としています。安全なセルフカストディのために設計されたハードウェアウォレットに注力しています。",
  "AboutUs.block2": "製品はセキュアエレメント、耐改ざん保護、完全オフラインアーキテクチャを組み合わせています。目的は、秘密鍵を隔離された環境に保持することです。",
  "AboutUs.block3": "システムは Wi‑Fi、USB、または直接的なネットワーク依存なしで設計されています。指紋アクセス、NFC バックアップ機能、幅広い資産対応により、日常利用でも実用性を保ちます。",
  "AboutUs.block5": "LUKKEY はコアのファームウェアとソフトウェアに対して、オープンで監査可能なアプローチを採用しています。セキュリティ上の主張は、確認可能で検証可能であるべきです。",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "サポートリクエスト",
  "WarrantySupport.intro":
    "サポートリクエストを送信するため、以下の情報を入力してください。",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "問題の概要",
  "WarrantySupport.form.issueTitle.placeholder": "簡単な概要を入力",
  "WarrantySupport.form.warrantyType.label": "リクエスト種別",
  "WarrantySupport.form.warrantyType.placeholder": "リクエスト種別を選択",
  "WarrantySupport.form.warrantyType.product": "デバイスの問題",
  "WarrantySupport.form.warrantyType.service": "アプリ／アカウントの問題",
  "WarrantySupport.form.warrantyType.replacement": "その他",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "問題またはリクエストの詳細を記入してください",
  "WarrantySupport.form.submit": "サポートリクエストを送信",
  "WarrantySupport.alert.success": "サポートリクエストを送信しました！",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "ヘルプセンター",
  "HelpCenter.intro":
    "LUKKEY ヘルプセンターへようこそ。暗号資産が初めての方や、コールドウォレットでお困りの方はこちらをご利用ください。LUKKEY のコールドウォレットは、デジタル資産を安全に保管・管理する最も安全な方法を提供します。以下に、よくある質問とトラブルシューティングのヒントをまとめました。",
  "HelpCenter.section4.title": "さらにサポートが必要ですか？",
  "HelpCenter.section4.intro":
    "オンラインでサポートリクエストを開始すると時間を節約でき、専門担当者につながります。安全のため、公式サポートがリカバリーフレーズや秘密鍵を求めることはありません：",
  "HelpCenter.contact.hint": "ボタンからサポートリクエストを送信すると、メールでご連絡します。",
  "HelpCenter.cta.warranty": "サポートリクエストを送信",
  brandName: "LUKKEY",
  tagline: "これまでにない方法で暗号通貨を管理する",
  description:
    "私たちのアプリで、財務自由への旅を始めましょう。進んだコールドウォレット技術で資産を守り、より賢明かつ効率的に財務を管理します。あなたの財務健康が私たちの最優先事項です。",
  "home.seoTitle": "LUKKEY | 安全なセルフカストディのためのスイス製ハードウェアウォレット",
  "home.seoDescription": "LUKKEY は、コールドウォレットの安全性、秘密鍵のオフライン保護、指紋認証、NFC バックアップに注力した、安全なセルフカストディのためのスイス発ハードウェアウォレットブランドです。",
  learnMore: "もっと知る",
  "Lock Your Crypto, Securely": "暗号通貨を安全にロック",
  Testimonials: "お客様の声",
  Testimonial1:
    "数ヶ月間このコールドウォレットを使用していますが、その信頼性とセキュリティ機能に感銘を受けています。強くお勧めします！",
  Testimonial2:
    "このコールドウォレットは私の期待を超えました！使いやすいインターフェースと最高レベルのセキュリティが、それを暗号通貨に真剣な人にとって必須のツールにしています。",
  Testimonial3:
    "いくつかのコールドウォレットを試しましたが、これが際立っています。洗練されたデザインと高度な機能で、暗号資産の管理がとても簡単になりました。",
  "John Doe": "ジョン・ドウ",
  "Cryptocurrency Enthusiast": "暗号通貨愛好者",
  "Jane Smith": "ジェーン・スミス",
  "Crypto Security Advocate": "暗号通貨セキュリティ提唱者",
  "Alex Johnson": "アレックス・ジョンソン",
  "Investment Analyst": "投資アナリスト",
  "Touchscreen Interface": "タッチスクリーンインターフェース",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "直感的なタッチスクリーンインターフェースを使って、簡単に暗号通貨を管理できます。デジタル資産を迅速かつ簡単にナビゲートし、迅速な取引と安全な管理を手のひらで実現します。",
  "Bluetooth Connectivity": "Bluetooth 接続",
  "Wireless syncing with your devices for real-time updates.":
    "デバイスとワイヤレスで同期し、リアルタイムで更新します。",
  "Airtag Tracking": "Airtag トラッキング",
  "Track your wallet easily with built-in Airtag.":
    "内蔵のAirtagで財布を簡単に追跡できます。",
  "Secure Chip Technology": "セキュアチップ技術",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "高度なセキュリティチップを搭載し、貴重なデジタル資産を不正アクセスやサイバー脅威から強力に保護します。",
  "Cross-Platform Support": "クロスプラットフォーム対応",
  "Works with various platforms for easy accessibility.":
    "さまざまなプラットフォームに対応しており、簡単にアクセスできます。",
  AboutUsDescription1:
    "LUKKEYでは、暗号資産を安全に管理するための高品質なソリューションを提供することに専念しています。",
  AboutUsDescription2:
    "本社はスイスのツークにあります。経験豊富なプロフェッショナルチームとともに、デジタル通貨市場の変化する風景に適応し、革新を目指しています。",
  BlockchainNetworksSupported: "サポートされているブロックチェーンネットワーク",
  CryptocurrenciesSupported: "6,000種類以上の暗号通貨に対応",
  Years: "年",
  ExpertiseInSecurity: "セキュリティの専門知識",
  FrequentlyAskedQuestions: "よくある質問",
  WhatIsColdWallet: "コールドウォレットとは何ですか？",
  ColdWalletDescription:
    "コールドウォレットは、デジタル資産をオフラインで保存する暗号通貨ウォレットの一種で、ハッキングやその他のオンライン脅威から守ります。インターネットに接続されており、頻繁な取引に便利なホットウォレットとは異なり、コールドウォレットは長期保管に最適で、強化されたセキュリティを提供します。",
  HowToSetUpColdWallet: "コールドウォレットを設定する方法は？",
  ColdWalletSetupDescription:
    "コールドウォレットの設定は通常、セキュアなオフラインマシンでデバイスを初期化することから始まります。デバイスの紛失や故障時に資産にアクセスするために必要なリカバリーフレーズを生成し、安全に保管する必要があります。購入時に提供される詳細な説明により、スムーズな設定プロセスが保証されます。",
  CryptocurrenciesCompatibleWithColdWallet:
    "どの暗号通貨がコールドウォレットに対応していますか？",
  CryptocurrenciesCompatibilityDescription:
    "当社のコールドウォレットは、Bitcoin、Ethereum、Litecoinなどの主要な暗号通貨をはじめ、さまざまなアルトコインに対応しています。サポートされている通貨の完全なリストについては、当社のウェブサイトをご覧いただくか、製品のドキュメントをご参照ください。",
  HowToSecureColdWallet: "コールドウォレットをどのように保護しますか？",
  ColdWalletSecurityDescription:
    "コールドウォレットのセキュリティを確保するためには、リカバリーフレーズを安全でプライベートな場所に保管し、他の人と共有しないようにし、バイオメトリックロックやセキュアな収納場所などの追加のセキュリティ対策を考慮してください。公式ウェブサイトから定期的にウォレットのファームウェアを更新することも、脆弱性から保護するために役立ちます。",
  ColdWalletNotWorking:
    "コールドウォレットが動作しない、またはエラーが発生した場合はどうすればよいですか？",
  ColdWalletErrorDescription:
    "コールドウォレットに問題が発生した場合は、ユーザーガイドのトラブルシューティングセクションをご参照ください。特定の問題については、ウェブサイトを通じてサポートチームにお問い合わせください。サポートプロセスを迅速に進めるために、デバイス情報を手元に準備しておいてください。",
  Community: "コミュニティ",

  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "お気に入りのプラットフォームでコミュニティに参加して、最新情報を入手し、質問をして、他のユーザーとつながりましょう。",
  "Subscribe.title": "製品アップデートを受け取る",
  "Subscribe.subtitle":
    "暗号資産のトレンドは私たちが追跡します。製品アップデート、市場インサイト、限定特典を—あなたの受信箱に直接お届けします。",
  "Subscribe.placeholder": "メールアドレスを入力",
  "Subscribe.button": "製品アップデートを購読",
  "Subscribe.input.aria": "メールアドレス入力欄",
  "Subscribe.success":
    "ご購読ありがとうございます。確認メールをお送りしましたのでご確認ください。",
  "Subscribe.error":
    "購読に失敗しました。しばらくしてからもう一度お試しください。",
  "Subscribe.invalid": "有効なメールアドレスを入力してください。",
  "Subscribe.privacy":
    "あなたのメールアドレスはニュースレターおよび更新情報の配信のみに使用します。メール内のリンクからいつでも購読を解除できます。",
  "Subscribe.learnMore":
    "データの取り扱いとお客様の権利について詳しくはこちら。",
  "Subscribe.popupCompact.title": "最新情報を受け取る",
  "Subscribe.popupCompact.subtitle":
    "製品アップデートとセキュリティ情報。スパムは送りません。",
  "Subscribe.popupCompact.button": "購読する",
  "Subscribe.popupCompact.privacy":
    "メール配信のみ。いつでも解除できます。",
  "SubscribeConfirmed.alt.success": "購読が確認されました",
  "SubscribeConfirmed.alt.failed": "購読に失敗しました",
  "SubscribeConfirmed.title.success": "購読が確認されました",
  "SubscribeConfirmed.title.failed": "購読に失敗しました",
  "SubscribeConfirmed.message.success":
    "メールの確認ありがとうございます。購読は有効になりました。ウェルカムメールを受信トレイに送信しました。",
  "SubscribeConfirmed.message.failed":
    "確認リンクが無効または期限切れです。ホームページに戻って、もう一度購読をお試しください。",
  "SubscribeConfirmed.cta.backHome": "ホームに戻る",
  "SubscribeConfirmed.note.unsubscribe":
    "メール内のリンクから、いつでも購読を解除できます。",
  // ===== MarketView i18n =====
  "MarketView.title": "マーケットダッシュボード",
  "MarketView.loading": "読み込み中...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X（Twitter）",
  "MarketView.tabError.failed": "このタブのレンダリングに失敗しました",
  "MarketView.unknownError": "不明なエラー",

  // ===== Common i18n =====
  "Common.refresh": "再読み込み",
  "Common.toggleSeriesVisibility": "この系列を切り替える",
  "Common.error": "エラー",
  "Common.dataUpdateTime": "データ更新時刻",
  "Common.loading": "読み込み中...",
  "Common.noDataSource": "データなし（データソースが未提供）",

  // ===== Common ranges =====
  "Common.to": "〜",
  "Common.clear": "クリア",
  "Common.range.thisMonth": "今月",
  "Common.range.lastMonth": "先月",
  "Common.range.last2": "直近2か月",
  "Common.range.last3": "直近3か月",
  "Common.range.last6": "直近6か月",
  "Common.range.thisYear": "今年",
  "Common.range.all": "すべて",
  "Common.range.custom": "カスタム",
  "Common.showFilters": "フィルターを表示",
  "Common.hideFilters": "フィルターを非表示",
  "Common.search": "検索",
  "Common.priority": "優先度",
  "Common.owner": "担当者",
  "Common.collaborator": "協力者",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle":
    "バックエンド data/youtube_stats.json をダウンロード",
  "YouTubeTab.downloadJson": "youtube_stats.json をダウンロード",
  "YouTubeTab.loading": "YouTube 指標を読み込み中...",
  "YouTubeTab.errorHint":
    "APIキーが未設定の場合は backend/.env に YOUTUBE_API_KEY または GOOGLE_API_KEY を設定し、バックエンドを再起動してください。",
  "YouTubeTab.header.totalViews": "総再生数（マルチチャネル、単位：10k）",
  "YouTubeTab.header.totalSubscribers":
    "総登録者数（マルチチャネル、単位：10k）",
  "YouTubeTab.dist.views": "再生数の分布（10k）",
  "YouTubeTab.dist.subscribers": "登録者の分布（10k）",
  "YouTubeTab.card.location": "所在地:",
  "YouTubeTab.card.registeredAt": "登録日:",
  "YouTubeTab.card.currentSubscribers": "現在の登録者数",
  "YouTubeTab.card.currentVideos": "現在の動画数",
  "YouTubeTab.card.currentTotalViews": "現在の総再生数",
  "YouTubeTab.card.currentTotalComments": "現在の総コメント数",
  "YouTubeTab.chart.totalSubscribers": "総登録者数",
  "YouTubeTab.chart.totalViews": "総再生数",
  "YouTubeTab.chart.totalComments": "総コメント数",
  "YouTubeTab.chart.totalVideos": "総動画数",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "バックエンド data/x_stats.json をダウンロード",
  "XTab.downloadJson": "x_stats.json をダウンロード",
  "XTab.loading": "X 指標を読み込み中...",
  "XTab.errorHint":
    "トークンが未設定の場合は backend/.env に X_BEARER_TOKEN または TWITTER_BEARER_TOKEN を設定し、バックエンドを再起動してください。",
  "XTab.header.totalFollowers": "フォロワー総数（マルチチャネル、単位：10k）",
  "XTab.header.totalEngagement":
    "総エンゲージメント（直近5件：いいね＋リツイート＋返信＋引用、単位：10k）",
  "XTab.dist.followers": "フォロワーの分布（10k）",
  "XTab.dist.engagement":
    "エンゲージメントの分布（直近5件：いいね＋リツイート＋返信＋引用、単位：10k）",
  "XTab.card.currentFollowers": "現在のフォロワー数",
  "XTab.card.currentFollowing": "現在のフォロー数",
  "XTab.card.currentTweets": "現在のツイート数",
  "XTab.card.recentLikes": "最近のいいね（直近5件）",
  "XTab.card.recentRetweets": "最近のリツイート（直近5件）",
  "XTab.card.recentReplies": "最近の返信（直近5件）",
  "XTab.card.recentQuotes": "最近の閲覧数（コンテンツレベル、直近5件）",
  "XTab.card.listed": "リスト掲載数（チャンネルレベル）",
  "XTab.smallChart.followers": "フォロワー",
  "XTab.smallChart.tweets": "ツイート",
  "XTab.smallChart.likes": "最近のいいね",
  "XTab.smallChart.retweets": "最近のリツイート",
  "XTab.smallChart.replies": "最近の返信",
  "XTab.smallChart.quotes": "最近の閲覧数（コンテンツレベル）",
  "XTab.smallChart.following": "フォロー",
  "XTab.smallChart.listed": "リスト掲載",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "作成月でフィルタ:",
  "Analytics.dashboardTitle": "プロジェクト健全性ダッシュボード",
  "Analytics.metric.completionRate": "完了率",
  "Analytics.metric.teamVelocity": "チーム速度",
  "Analytics.metric.blockerRatio": "ブロッカー比率",
  "Analytics.metric.workloadBalance": "作業負荷バランス",
  "Analytics.charts.statusDistribution": "ステータス分布",
  "Analytics.charts.statusByMonthPercent": "月別ステータス（割合）",
  "Analytics.charts.priorityDistribution": "優先度分布",
  "Analytics.charts.priorityByMonthPercent": "月別優先度（割合）",
  "Analytics.charts.functionTypeDistribution": "機能タイプ分布",
  "Analytics.charts.functionTypeByMonthPercent": "月別機能タイプ（割合）",
  "Analytics.blocker.ownerPie": "ブロックされた課題 · 担当者分布（ドーナツ）",
  "Analytics.blocker.ownerByMonth": "ブロックされた課題 · 月別担当者（割合）",
  "Analytics.bug.ownerPie": "バグ課題 · 担当者分布（ドーナツ）",
  "Analytics.bug.ownerByMonth": "バグ課題 · 月別担当者（割合）",
  "Analytics.ownerWorkloadDistribution": "チーム作業量の分布",
  "Analytics.mode.priority": "優先度分布",
  "Analytics.mode.status": "ステータス分布",
  "Analytics.mode.type": "タイプ分布",
  "Analytics.blocker.attentionNeeded": "即時対応が必要な課題",
  "Analytics.common.status": "ステータス",
  "Analytics.common.owner": "担当者",
  "Analytics.insights.sectionTitle": "プロジェクトの洞察と提案",
  "Analytics.insights.efficiency.title": "効率改善の提案",
  "Analytics.insights.efficiency.completionRate":
    "• 現在の完了率は {{rate}}% です。ブロッカーに注意してください",
  "Analytics.insights.efficiency.avgVelocity":
    "• チーム平均速度は {{velocity}} 件/人です",
  "Analytics.insights.efficiency.workloadBalance":
    "• 作業負荷バランスは {{balance}}% です",
  "Analytics.insights.risk.title": "リスク警告",
  "Analytics.insights.risk.blockerRatio": "• ブロッカー比率 {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• P0課題の比率 {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• 優先度の高い課題から対応してください",

  // ===== Kanban i18n =====
  "Kanban.title": "カンバンビュー",
  "Kanban.totalIssues": "合計 {{count}} 件の課題",
  "Kanban.searchPlaceholder": "タイトル、課題番号、担当者または協力者を検索...",
  "Kanban.status.backlog": "バックログ",
  "Kanban.status.inProgress": "進行中",
  "Kanban.status.blocked": "ブロック／確認待ち",
  "Kanban.status.reviewTest": "レビュー／テスト",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "課題一覧",
  "List.totalIssues": "合計 {{count}} 件の課題",
  "List.viewDetails": "詳細を表示",
  "List.openInNewWindow": "新しいウィンドウで開く",
  "List.empty.title": "課題なし",
  "List.empty.subtitle": "最初の課題を作成してワークフローを始めましょう",

  // ===== Assets Register i18n =====
  "Assets.title": "資産登録",
  "Assets.totalSets": "合計セット数",
  "Assets.table.employee": "従業員",
  "Assets.table.setCount": "セット数",
  "Assets.table.model": "モデル",
  "Assets.total": "合計",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "プロジェクト課題トラッキング",
  "LukkeyIssues.goToDemo": "デモページへ",
  "LukkeyIssues.githubProject": "GitHub プロジェクト ↗",
  "LukkeyIssues.githubManageIssues": "GitHub で直接 Issues を管理 ↗",
  "LukkeyIssues.financeModel": "ファイナンスモデル",
  "LukkeyIssues.productCoreIssues": "プロダクト中核課題",
  "LukkeyIssues.stats.totalIssues": "📊 課題総数",
  "LukkeyIssues.stats.completed": "✅ 完了",
  "LukkeyIssues.stats.inProgress": "🔄 進行中",
  "LukkeyIssues.stats.pending": "⏳ 保留",
  "LukkeyIssues.stats.blocked": "🚫 ブロック",
  "LukkeyIssues.stats.docs": "📚 ドキュメント Docs",
  "LukkeyIssues.tabs.kanban": "カンバンビュー",
  "LukkeyIssues.tabs.analytics": "アナリティクス",
  "LukkeyIssues.tabs.market": "マーケットダッシュボード",
  "LukkeyIssues.tabs.assets": "資産登録",
  "LukkeyIssues.shareToChatGPT": "ChatGPT で LUKKEY.json を開く", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "LUKKEY プライバシーポリシー",
  "PrivacyPolicy.intro.p1":
    "LUKKEY は、最も安全なプライバシーとは、常にユーザー自身の手中にあるものだと考えています。",
  "PrivacyPolicy.intro.p2":
    "そのため、LUKKEY のハードウェア・コールドウォレットやモバイルアプリ（App）をご利用の場合でも、当社は次の不変の原則を厳格に順守します。",
  "PrivacyPolicy.intro.p3_strong":
    "ユーザーの明示的な許可がない限り、当社は一切のユーザー情報を収集・保存・送信しません。",
  "PrivacyPolicy.intro.p3_tail":
    "利用に関するすべてのデータはユーザーの端末内にのみ保存され、LUKKEY やいかなるサーバーにも送信されることはありません。",
  "PrivacyPolicy.intro.p4":
    "本プライバシーポリシーは、当社がこの原則をどのように実践しているかを説明します。",

  "PrivacyPolicy.s1.title": "1. 適用範囲",
  "PrivacyPolicy.s1.appliesTo": "本プライバシーポリシーは次に適用されます：",
  "PrivacyPolicy.s1.item.hardware": "LUKKEY ハードウェア・コールドウォレット",
  "PrivacyPolicy.s1.item.app": "LUKKEY モバイルアプリ（App）",
  "PrivacyPolicy.s1.principle":
    "いずれも「ゼロ収集・ゼロ送信・ローカル保存のみ」という統一原則に従います。",

  "PrivacyPolicy.s2.title": "2. 収集しない情報",
  "PrivacyPolicy.s2.desc":
    "プライバシー保護のため、当社は以下を含むあらゆるユーザー情報を収集・送信・保存しないことを明確に約束します。",
  "PrivacyPolicy.s2.li.identity":
    "本人情報：氏名、電話番号、メールアドレス、郵送先住所",
  "PrivacyPolicy.s2.li.walletSensitive":
    "ウォレットの機微情報：秘密鍵、ニーモニック、keystore ファイル、ウォレットのパスワード",
  "PrivacyPolicy.s2.li.blockchain":
    "ブロックチェーン情報：ウォレットアドレス、取引履歴、資産情報",
  "PrivacyPolicy.s2.li.behavior":
    "利用行動：アプリログ、クリック記録、行動分析",
  "PrivacyPolicy.s2.li.technical":
    "技術情報：端末識別子、位置情報、IP アドレス",
  "PrivacyPolicy.s2.inShort.title": "要するに：",
  "PrivacyPolicy.s2.inShort.desc":
    "ハードウェア機器やアプリで見えるすべてはお使いの端末のみに存在し、LUKKEY はアクセスできません。",

  "PrivacyPolicy.s3.title":
    "3. ハードウェア・コールドウォレットのプライバシーとセキュリティ設計",
  "PrivacyPolicy.s3.desc":
    "LUKKEY のコールドウォレットは、完全オフラインの安全な環境を提供します。主な特徴：",
  "PrivacyPolicy.s3.h1.title": "1. 軍用レベルのセキュリティハードウェア",
  "PrivacyPolicy.s3.h1.l1": "EAL6+ 認証のセキュアエレメント",
  "PrivacyPolicy.s3.h1.l2": "ハードウェアレベルの暗号化通信",
  "PrivacyPolicy.s3.h2.title": "2. セキュリティ機能",
  "PrivacyPolicy.s3.h2.l1": "指紋認証",
  "PrivacyPolicy.s3.h2.l2": "プライバシーモード",
  "PrivacyPolicy.s3.h2.l3": "マルチウォレットの分離管理",
  "PrivacyPolicy.s3.h3.title": "3. 完全な分離",
  "PrivacyPolicy.s3.h3.l1": "インターネット接続なし",
  "PrivacyPolicy.s3.h3.l2": "データケーブル接続なし",
  "PrivacyPolicy.s3.h4.title": "4. 改ざん耐性のセルフデストラクト",
  "PrivacyPolicy.s3.h4.desc":
    "機器が分解・破損・異常侵入を受けた場合、セキュアエレメントは機微データを自動的に破壊し、秘密鍵の抽出を防ぎます。",
  "PrivacyPolicy.s3.h5.title": "5. 機微な操作はセキュアエレメント内のみで実行",
  "PrivacyPolicy.s3.h5.l1": "ウォレットの作成",
  "PrivacyPolicy.s3.h5.l2": "ウォレットのインポート",
  "PrivacyPolicy.s3.h5.l3": "トランザクション署名",
  "PrivacyPolicy.s3.h5.note":
    "機微なプロセスは 100% セキュアエレメント内で行われ、非セキュアなチップやストレージに露出しません。",
  "PrivacyPolicy.s3.h6.title":
    "6. セキュアエレメント外に機微データを保存しない",
  "PrivacyPolicy.s3.h6.desc":
    "端末の非セキュア領域に秘密鍵・ニーモニックなどの機微情報は保存しません。",

  "PrivacyPolicy.s4.title": "4. LUKKEY アプリのプライバシーとセキュリティ設計",
  "PrivacyPolicy.s4.desc":
    "LUKKEY アプリは情報表示と通知に特化し、ウォレットの機微データは扱いません。",
  "PrivacyPolicy.s4.n1.title": "1. アプリが行わないこと",
  "PrivacyPolicy.s4.n1.l1": "ブロックチェーンウォレットを生成しない",
  "PrivacyPolicy.s4.n1.l2": "ブロックチェーンウォレットをインポートしない",
  "PrivacyPolicy.s4.n1.l3": "秘密鍵やニーモニックを保存しない",
  "PrivacyPolicy.s4.n1.l4": "ユーザーデータをアップロードしない",
  "PrivacyPolicy.s4.n1.l5": "行動分析・広告トラッキング・データ収集を行わない",
  "PrivacyPolicy.s4.n2.title": "2. アプリが行うこと",
  "PrivacyPolicy.s4.n2.l1": "ハードウェアにより許可された公開情報を表示",
  "PrivacyPolicy.s4.n2.l2":
    "各権限の目的を説明するプライバシー設定パネルを提供",
  "PrivacyPolicy.s4.n2.l3": "権限の有効/無効をいつでもユーザーが制御可能",
  "PrivacyPolicy.s4.n2.l4": "機微情報のマスキングを提供",
  "PrivacyPolicy.s4.n2.l5": "特定画面でのスクリーンショット/録画を無効化",
  "PrivacyPolicy.s4.n2.l6":
    "ローカル照合で不審なブロックチェーンアドレスを検知",
  "PrivacyPolicy.s4.n2.l7": "危険な URL・コントラクト・アドレスを定期的に更新",
  "PrivacyPolicy.s4.n2.l8": "更新フローは一方向（サーバー → 端末）のみ",
  "PrivacyPolicy.s4.n2.l9": "更新時にユーザーデータは一切送信されません",
  "PrivacyPolicy.s4.n3.title": "3. ローカルストレージ",
  "PrivacyPolicy.s4.n3.p1":
    "アプリは UI 設定・言語・テーマなどの非機微データのみをローカル保存します。これらのデータは：",
  "PrivacyPolicy.s4.n3.l1": "アップロードされない",
  "PrivacyPolicy.s4.n3.l2": "同期されない",
  "PrivacyPolicy.s4.n3.l3": "LUKKEY からアクセスされない",

  "PrivacyPolicy.s5.title": "5. データ伝送とサーバーポリシー",
  "PrivacyPolicy.s5.l1": "LUKKEY のサーバーはユーザー情報を保存しません",
  "PrivacyPolicy.s5.l2":
    "アプリとサーバーの通信はデータベース更新およびバージョン更新に限定されます",
  "PrivacyPolicy.s5.l3": "通信中にユーザー情報は送信されません",
  "PrivacyPolicy.s5.l4":
    "仮にサーバーが侵害されても、当社はそもそも当該データを取得しないため、ユーザーデータが露出することはありません",

  "PrivacyPolicy.s6.title": "6. オープンソースの透明性",
  "PrivacyPolicy.s6.l1": "LUKKEY アプリのソースコードはオープンソースです",
  "PrivacyPolicy.s6.l2":
    "LUKKEY ハードウェアの組み込みファームウェアもオープンソースです",
  "PrivacyPolicy.s6.l3": "GitHub で誰でも監査可能です",
  "PrivacyPolicy.s6.p": "透明性はセキュリティの一部です。",

  "PrivacyPolicy.s7.title": "7. ユーザーによる完全なコントロール",
  "PrivacyPolicy.s7.p":
    "当社がユーザー情報を収集しない場合でも、ユーザーは自身のデバイスを完全にコントロールできます：",
  "PrivacyPolicy.s7.l1": "いつでもアプリの権限を無効にできます",
  "PrivacyPolicy.s7.l2":
    "アプリを削除してローカルのアプリデータをすべて消去できます",
  "PrivacyPolicy.s7.l3":
    "ハードウェアデバイスをリセットして秘密鍵とウォレットデータを完全消去できます",
  "PrivacyPolicy.s7.p2": "LUKKEY はこれらの操作に介入せず、介入もできません。",

  "PrivacyPolicy.s8.title": "8. お問い合わせ",
  "PrivacyPolicy.s8.p":
    "本プライバシーポリシーに関するご質問は、以下までお問い合わせください：",
  "PrivacyPolicy.s8.email": "メール: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "住所: LUKKEY 本社, Baarerstrasse 25, 6300 Zug, Switzerland",
  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "確認中...",
  "EmailOtp.title":
    "アクセス制限: サインインコードを取得するために氏名とメールアドレスを入力してください",
  "EmailOtp.nameLabel": "氏名",
  "EmailOtp.namePlaceholder": "氏名を入力してください",
  "EmailOtp.emailLabel": "メールアドレス",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "コードを送信",
  "EmailOtp.resendCode": "コードを再送",
  "EmailOtp.resendWithCountdown": "再送 ({{s}}s)",
  "EmailOtp.codeValidityHint": "認証コードの有効期限は約10分です",
  "EmailOtp.codeLabel": "メール認証コード",
  "EmailOtp.codePlaceholder": "受け取ったコードを入力",
  "EmailOtp.signIn": "サインイン",
  "EmailOtp.message.codeSent":
    "認証コードを送信しました。メールをご確認ください",
  "EmailOtp.error.nameRequired": "氏名を入力してください",
  "EmailOtp.error.invalidEmail": "有効なメールアドレスを入力してください",
  "EmailOtp.error.sendFailed":
    "認証コードの送信に失敗しました。しばらくしてから再試行してください。",
  "EmailOtp.error.codeRequired": "認証コードを入力してください",
  "EmailOtp.error.verificationFailed": "認証に失敗しました",
  // ===== Academy i18n =====
  "Academy.hero.alert":
    "セキュリティ注意：リンクを必ず確認し、リカバリーフレーズは決して共有しないでください。",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "アカデミー",
  "Academy.hero.subtitle":
    "暗号資産のセキュリティ、セルフカストディ、LUKKEY コールドウォレットの使い方に関する実践ガイド。",
  "Academy.search.placeholder":
    "チュートリアル、ベストプラクティス、FAQ を検索…",
  "Academy.search.hint": "[Enter]",
  "Academy.card.type.article": "記事",
  "Academy.list.title": "最新ガイド",
  "Academy.list.viewAll": "すべて見る",
  "Academy.list.empty": "結果がありません。別のキーワードをお試しください。",
  "Academy.image.placeholder": "画像",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "アカデミーへ戻る",
  "AcademyArticle.notFound": "記事が見つかりません",
  "AcademyArticle.author": "著者",
  "AcademyArticle.unscheduled": "公開予定はありません",
  "home.hero.reserveCtaLabel": "先行アクセス — 1ドル",
  "home.hero.reserveCtaNote": "全額返金可能。購入の約束は不要です。"
};
export default translation;
